var _title;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 26.74"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "star full2")), /*#__PURE__*/React.createElement("path", {
  d: "M6,27.41l1.07-8.49L1.22,12.64a.85.85,0,0,1,.44-1.41l8.4-1.68L14.22,2a.91.91,0,0,1,1.5,0l4.16,7.52,8.4,1.68a.81.81,0,0,1,.44,1.41l-5.84,6.28,1.06,8.49a.86.86,0,0,1-1.23.88L15,24.67,7.23,28.29A.89.89,0,0,1,6,27.41Z",
  transform: "translate(-1 -1.63)",
  style: {
    fill: "#fff800"
  }
}));
export default SvgStarFilled;